module.exports = __webpack_public_path__ + "media/images/return-icon-fbca9aaaa98adbea30d06e5e2334d54f.png";